export const parseBonusPoints = (bonusPoints: number): string => {
  if (bonusPoints < 1000) {
    return bonusPoints.toString();
  }

  const value = bonusPoints / 1000;
  const rounded = parseFloat(value.toFixed(1));
  return `${rounded.toString()}K`;
};
